<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="search_name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">手机号：</span>
					<el-input v-model="search_mobile" class="b_inp" placeholder="手机号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">机构名称：</span>
					<el-input v-model="search_firm" class="b_inp" placeholder="机构名称"></el-input>
				</div>
			
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddTrainerClick">新增训练师</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="mobile"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="sexLabel"
						label="性别"
					>
					</el-table-column>
					<el-table-column
						prop="age"
						label="年龄"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="机构名称"
					>
					</el-table-column>
					<el-table-column
						prop="createTime"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateTrainerClick(scope.row)"
							>修改</el-button>
							<el-button
								type="danger"
								@click="handleDeleteTrainerClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增带训人 -->
		<AddTrainer v-model="add_display" @success="getList"></AddTrainer>
		<!-- 新增带训人 end -->
		
		<!-- 修改带训人 -->
		<UpdateTrainer v-model="update_display" :obj="selected_item" @success="getList"></UpdateTrainer>
		<!-- 修改带训人 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	import AddTrainer from './components/add_master.vue';
	import UpdateTrainer from './components/update_master.vue';
	
	export default {
		mounted() {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,

				search_name: '',
				search_mobile: '',
				search_firm: '',
				
				selected_item: {},
				
				add_display: false,
				
				update_display: false
			}
		},
		methods: {
			/******************* @Events **********************/
			// 点击查询
			handleSearchClick() {
				this.getList();
			},
			// 点击新增训练师
			handleAddTrainerClick() {
				this.add_display = true;
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			// 点击修改
			handleUpdateTrainerClick(data) {
				this.selected_item = data;
				this.update_display = true;
			},
			// 点击删除
			handleDeleteTrainerClick(data) {
				const that = this;
				this.$confirm(
					'您确定要删除该带训人？', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteTrainer(data.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************* @Function **********************/
			// 获取表格数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					code: that.search_mobile,
					enterpriseName: that.search_firm,
					limit: 10,
					name: that.search_name,
					pageNum: that.currentPage
				};
				Api.findTrainerByCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								name: _o.eglTrainerName,
								mobile: _o.code,
								sex: _o.sex,
								sexLabel: _o.sex == 0 ? '男' : (_o.sex == 1 ? '女' : ''),
								age: _o.age,
								birth: _o.birth.indexOf(' ') != -1 ? _o.birth.split(' ')[0] : _o.birth,
								firmId: _o.uenterpriseId,
								firmName: _o.uenterpriseName,
								createTime: BaseMethods.formatTime(_o.createTime, 'yy-mm-dd hh:mm:ss')
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除带训人
			deleteTrainer(trainerId) {
				const that = this;
				that.loading = true;
				var requestData = {
					id: trainerId
				};
				Api.deleteTrainer(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			AddTrainer,
			UpdateTrainer
		}
	}
</script>

<style scoped>
</style>
